// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:5px}::-webkit-scrollbar-thumb,::-webkit-scrollbar-track{border-radius:10px;background-color:rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
